var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgContacts = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128pt",
    height: "128pt",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m100.48 8.9609h-72.961c-7.0703 0-12.801 5.7305-12.801 12.801v84.477c0 3.3984 1.3516 6.6523 3.75 9.0508 2.4023 2.4023 5.6562 3.75 9.0508 3.75h72.961c3.3945 0 6.6484-1.3477 9.0508-3.75 2.3984-2.3984 3.75-5.6523 3.75-9.0508v-84.477c0-3.3984-1.3516-6.6523-3.75-9.0508-2.4023-2.4023-5.6562-3.75-9.0508-3.75zm-67.84 104.96h-5.1211c-4.2422 0-7.6797-3.4414-7.6797-7.6836v-84.477c0-4.2422 3.4375-7.6836 7.6797-7.6836h5.1211zm38.398-76.02c5.6406 0 10.723 3.3945 12.879 8.6016 2.1562 5.2109 0.96484 11.207-3.0195 15.191-3.9883 3.9883-9.9844 5.1797-15.191 3.0234-5.2109-2.1562-8.6055-7.2422-8.6055-12.879 0.007813-7.6953 6.2422-13.934 13.938-13.938zm23.602 52.734h-47.203v-7.9609c-0.003906-0.38281 0.082031-0.75781 0.24219-1.1016 2.2656-4.1875 5.6484-7.668 9.7734-10.047 4.1211-2.3828 8.8281-3.5742 13.586-3.4453 4.7617-0.12891 9.4648 1.0625 13.59 3.4453 4.1211 2.3789 7.5039 5.8594 9.7695 10.047 0.16406 0.34375 0.24609 0.71875 0.24609 1.1016z",
    fill: "#00abe6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgContacts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/contacts.75b930f50a9b4dba4b229cd306abcda3.svg";